var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuditItems(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F0B429"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8625 14.4875V16.5062C17.8625 18.1875 17.1875 18.8625 15.5062 18.8625H13.4875C11.8062 18.8625 11.1312 18.1875 11.1312 16.5062V14.4875C11.1312 12.8063 11.8062 12.1312 13.4875 12.1312H15.5062C17.1937 12.1375 17.8625 12.8063 17.8625 14.4875Z",
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 11.6062V13.625C20.75 15.3063 20.075 15.9812 18.3937 15.9812H17.8625V14.4938C17.8625 12.8125 17.1875 12.1375 15.5062 12.1375H14.0187V11.6062C14.0187 9.92499 14.6937 9.25 16.375 9.25H18.3937C20.075 9.25 20.75 9.92499 20.75 11.6062Z",
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 19.3938V17.375C8.25 15.6937 8.925 15.0188 10.6063 15.0188H11.1375V16.5062C11.1375 18.1875 11.8125 18.8625 13.4937 18.8625H14.9813V19.3938C14.9813 21.075 14.3063 21.75 12.625 21.75H10.6063C8.925 21.75 8.25 21.075 8.25 19.3938Z",
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditItems);
export default __webpack_public_path__ + "static/media/auditItems.37a2b2d40cc91bfb453c355944766149.svg";
export { ForwardRef as ReactComponent };